import React from 'react'
import NavbarContainer from '../components/NavbarContainer/NavbarContainer'
import Footer from '../components/Footer/Footer'
import PublicAllExpensesContainer from '../components/PublicAllExpensesContainer/PublicAllExpensesContainer'
import CommonHeader from '../components/CommonHeader/CommonHeader'
import { useSelector } from 'react-redux'

function PublicAllExpenses() {
        const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div>
      <NavbarContainer/>
      <CommonHeader
      title={currentLocal.home.Registrationandtuitionfees}
      />
      <PublicAllExpensesContainer/>
      <Footer/>
    </div>
  )
}

export default PublicAllExpenses